export const FORGOT_PASSWORD_SIGNIN_CLICK = 'forgot.password.signin.click';
export const PASSWORD_RESET = 'password.reset';

export type ServiceForgotPasswordEvents = {
    [FORGOT_PASSWORD_SIGNIN_CLICK]: undefined;
    [PASSWORD_RESET]: undefined;
};
